import React from 'react';

import { currentUserIDState } from '@atom/setting/user';
import Button from '@components/dataEntry/button/Button';
import { dropdownDirMap } from '@components/wrapper/DropdownWrapper';
import { fuego } from '@nandorojo/swr-firestore';
import { cookieStore } from '@store/cookie/cookieStore';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import UserSec from './UserSec';
import { soundEffectState } from '@atom/setting/soundEffect';
import { registerOpenState } from '@atom/modal/modal';
import styled from 'styled-components';
import useValidLogin from '@hooks/useValidLogin';

const BtnWrap = styled.div`
  display: flex;
  padding: 0 12px;
`;
type Props = {
  dropdownDir?: keyof typeof dropdownDirMap;
  size?: string;
  showDisplayName?: boolean;
  style?: any;
};

function LoginUserSec({ dropdownDir, size, showDisplayName, style }: Props) {
  const isValidLogin = useValidLogin();
  const soundEffect = useRecoilValue(soundEffectState);
  const setOpenModal = useSetRecoilState(registerOpenState);

  return (
    <>
      {isValidLogin ? (
        <UserSec
          style={style}
          dropdownDir={dropdownDir || 'topRight'}
          size={size || '32px'}
          showDisplayName={showDisplayName}
          soundEff={
            soundEffect && {
              isActive: soundEffect.isActive,
              volume: soundEffect.volume,
              listSound: {
                name: '',
                url: soundEffect.listSound?.url || '',
              },
            }
          }
        />
      ) : (
        <BtnWrap>
          <Button shape="stroke" onClick={() => setOpenModal(true)}>
            로그인
          </Button>
        </BtnWrap>
      )}
    </>
  );
}

export default LoginUserSec;
